import styled from 'styled-components'

export default styled('button')`
  display: flex;
  align-items: center;
  background-color: #FAFBFD;
  border: 1px solid;
  border-radius: 5px;
  color: ${props => props.theme.palette.primaryColor};
  cursor: pointer;
  font-size: 14px;
  height: 38px;
  outline: none;
  padding: 0 15px;
  transition: ${props => props.theme.transition};
  &:hover {
    background-color: ${props => props.theme.palette.primaryColor};
    color: white;
  }
  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`
